import { render, staticRenderFns } from "./PlatformOpenPositionsTable.vue?vue&type=template&id=ba627c14&"
import script from "./PlatformOpenPositionsTable.vue?vue&type=script&lang=js&"
export * from "./PlatformOpenPositionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports